{
  "create": "Créer un modèle",
  "createTemplate": "Créer un modèle d'actifs",
  "templateName": "Nom du modèle",
  "modelFamily": "Famille de modèle",
  "description": "Description",
  "dateModified": "Date de modification",
  "status": "Statut",
  "filters": {
    "state": "Statut"
  },
  "states": {
    "active": "Actif",
    "draft": "Brouillon",
    "archived": "Archivé",
    "any": "Tous"
  },
  "actions": {
    "edit": "Modifier le modèle",
    "activate": "Activer le modèle",
    "moveToDraft": "Déplacer vers brouillon",
    "moveToArchive": "Déplacer vers archives"
  },
  "detailsModal": {
    "title": "Détails du modèle",
    "assetClasses": "Catégories d'actifs",
    "close": "Fermer"
  },
  "error": {
    "transition": "Échec de la mise à jour du statut du modèle",
    "update": "Échec de la mise à jour du modèle"
  },
  "success": {
    "transition": "Statut du modèle mis à jour avec succès",
    "update": "Modèle mis à jour avec succès"
  }
}
